import { initSgBootstrap } from '@/utils/theme';

initSgBootstrap();
